import React, { Component } from "react";
import classNames from "classnames";

import arrowIcon from "images/icons/down-arrow.svg";

class CollapsibleItem extends Component {
    onClick = () => {
        this.props.onClick(this.props.label);
    };

    render() {
        const { isOpen, label } = this.props;
        return (
            <React.Fragment>
                <div className="collapsible-item">
                    <div
                        onClick={this.onClick}
                        className={classNames("collapsible-item__title", {
                            "title-open-style": isOpen,
                        })}
                    >
                        {label}{" "}
                        <div
                            className={classNames(
                                "collapsible-item__title-arrow",
                                { "open-up-arrow": isOpen }
                            )}
                        >
                            <img src={arrowIcon} alt="arrow icon" />
                        </div>
                    </div>
                    {isOpen && (
                        <div className="collapsible-item__content">
                            {this.props.children}
                        </div>
                    )}
                </div>
                <div
                    className={classNames("collapsible-item__hr", {
                        "collapsible-item__hr-clrChange": isOpen,
                    })}
                ></div>
            </React.Fragment>
        );
    }
}

export default CollapsibleItem;
